import React from 'react';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/styles/withStyles';
import styles from './Details.styles';

const Detail = ({
	classes,
	detail,
}) => {

	return (
		<Typography className={classes.root}>
			{detail}
		</Typography>
	);
};

export default withStyles(styles)(Detail);
